// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"BackButton_backBtn__Mifzl","icon":"BackButton_icon__1Wd2s"};